var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNotification(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.50004 14.1667V15C7.50004 15.663 7.76343 16.2989 8.23227 16.7678C8.70111 17.2366 9.337 17.5 10 17.5C10.6631 17.5 11.299 17.2366 11.7678 16.7678C12.2366 16.2989 12.5 15.663 12.5 15V14.1667M8.33337 4.16667C8.33337 3.72464 8.50897 3.30072 8.82153 2.98816C9.13409 2.67559 9.55801 2.5 10 2.5C10.4421 2.5 10.866 2.67559 11.1786 2.98816C11.4911 3.30072 11.6667 3.72464 11.6667 4.16667C12.6237 4.61919 13.4395 5.32361 14.0267 6.20442C14.614 7.08523 14.9504 8.10923 15 9.16667V11.6667C15.0628 12.1848 15.2462 12.6809 15.5357 13.1151C15.8252 13.5493 16.2126 13.9095 16.6667 14.1667H3.33337C3.78749 13.9095 4.17488 13.5493 4.46436 13.1151C4.75385 12.6809 4.93733 12.1848 5.00004 11.6667V9.16667C5.04967 8.10923 5.38612 7.08523 5.97333 6.20442C6.56054 5.32361 7.37637 4.61919 8.33337 4.16667Z",
    stroke: "#262626",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNotification);
export default __webpack_public_path__ + "static/media/notification.4e902356ca17364a54139e86bb706ef7.svg";
export { ForwardRef as ReactComponent };